export enum LocalStorageEnum {}

export enum SessionStorageEnum {
  preAzetSearchPath = 'preAzetSearchPath',
  preAzetCount = 'preAzetCount',
  azetRegisterFlag = 'azetRegisterFlag',
}
